import { useMemo, type JSX } from 'react';
import { Chatbot, ChatbotProvider, type ChatbotConfig } from '@footsteps/shared';

import { WozFindAddressModal, WozSelectAddressModal, WozSelectAddressesModal, WozSyncingModal } from '../modals';
import { useWozCase } from '../woz-case-manager.provider';
import { WozUserAvatar } from './WozChatAvatar';

export const WozCase = (): JSX.Element => {
  const { caseViewModel, caseState, chatbotState, chatbotViewModel } = useWozCase();
  const { activeModal } = caseState;

  const chatbotConfig = useMemo<ChatbotConfig>(
    () => ({
      storagePrefix: 'woz-case',
      avatar: {
        assistant: {
          type: 'image',
          value: '/images/chatbot-avatar-512.png',
          alt: 'Assistent',
          className: 'chatbot-avatar chatbot-avatar--assistant',
        },
        support: {
          type: 'initials',
          value: 'M',
          className: 'chatbot-avatar chatbot-avatar--support',
        },
        user: {
          type: 'custom',
          component: WozUserAvatar,
        },
      },
      roleLabels: {
        assistant: 'Assistent',
        support: 'Medewerker',
      },
      inputPlaceholder: 'Type een bericht...',
      inputDisabledPlaceholder: 'Even geduld...',
      sendButtonLabel: 'Verstuur',
      sendButtonAriaLabel: 'Verstuur bericht',
      eventBridge: caseViewModel.eventBridge,
    }),
    [caseViewModel.eventBridge]
  );

  return (
    <>
      <ChatbotProvider config={chatbotConfig}>
        <Chatbot state={chatbotState} viewModel={chatbotViewModel} />
      </ChatbotProvider>
      <WozFindAddressModal
        open={activeModal?.type === 'find-address'}
        onClose={() => caseViewModel.closeModal()}
        onConfirm={caseViewModel.completeAction}
      />
      <WozSelectAddressModal
        open={activeModal?.type === 'select-address'}
        onClose={() => caseViewModel.closeModal()}
        onConfirm={caseViewModel.completeAction}
      />
      <WozSelectAddressesModal
        open={activeModal?.type === 'select-addresses'}
        onClose={() => caseViewModel.closeModal()}
        onConfirm={caseViewModel.completeAction}
      />
      <WozSyncingModal open={caseState.isSyncing} />
    </>
  );
};
